import LAZY_DISP from "../plugins/lazydisp"

const [ w, d, l ] = [ window, document, location ]

const is_recruit = id => {
  let param
  if( l.search != "" && /mode=detail/.test( l.search ) ){
    param = parseInt( l.search.match(/^\?mode=detail&article=([\d]+)/)[1] )
  }
  if( l.search == "" ){
    param = 1
  }
  return param == id
}
const is_recruit_cat = id => {
  let param
  if( l.search != "" && w.query_string('cat') ){
    param = parseInt( l.search.match(/^\?mode=list&cat=([\d]+)/)[1] )
  }
  return param == id
}

// 求める人物像のページで実行
const recruit01_init = () => {
}

// 募集要項カテの詳細ページで実行
const recruit_outline_init = data => {
  let $title = $(`<h3 class="recruit-outline__title"><span>${data[0].title}</span></h3>`)
  // 詳細ページクラス付与
  $('.element_detail').addClass('recruit-outline')

  // 標準タイトル削除
  $('.detail_title','.element_detail').remove()

  $title.prependTo('.recruit-outline')
  $('.nav-recruit').each((i,obj) => {
    let url = l.pathname+'?mode=list&cat=2'
    $(obj).currentMenu({url})
  })
}

// 募集要項リストページで実行
const recruit_list_init = () => {
  let catNameDOM = d.querySelector('.element_list .list_title1')
  let catName = catNameDOM.innerText
  let $title = $(`<h3 class="recruit-list__title"><span>${catName}</span></h3>`)
  catNameDOM.parentNode.removeChild( catNameDOM )

  $title.prependTo('.recruit-list')
}

const init = async () => {
  let nav = await $.get('/asset/html/nav-recruit.html')
  let process = await $.get('/asset/html/block-recruit-process.html')

  $('.element_list').addClass('recruit-list')

  w.load['header'].done(() => {
    $('.p-gnav__list').each((i,obj) => {
      let url = '/aboutus/'
      $(obj).currentMenu({url})
    })
  })

  if( is_recruit(1) ){
    // recruit01_init()
    w.load['recruit-01'].done( recruit01_init )
  }
  
  w.load['loadHtml'].done(() => {
    $('[data-plugin="currentMenu"]').currentMenu({mode:0,default:999})
    let $nav = $(nav).currentMenu({mode:0,default:999})
    $nav.clone(true).appendTo('.mainImgInner')
  })

  if( is_recruit(1) || is_recruit_cat(2) || w.query_string('mode') == 'list' ){
    $(process).insertAfter('.element_detail, .element_list')
    LAZY_DISP('[data-lazydisp]')
  }

  // 募集要項カテゴリだったら
  if( w.query_string('cat') == 2 ) recruit_list_init()

  // 詳細ページだったら
  if( w.query_string('article') ){
    let data = await $.getJSON('/asset/api/getArticles/',{
      content: 'recruit',
      post_id: w.query_string('article')
    })

    // 募集要項 detailだったら
    if( parseInt( data[0].category ) == 2 ) recruit_outline_init( data )
  }
}

export default function RECRUIT() {
  $(() => init() )
}